export default __webpack_public_path__ + "static/media/file11.e8e86d7b.jpg";